import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { NgModule, inject } from '@angular/core';
import { environment } from '@env/environment';
import { EffectsModule } from '@ngrx/effects';
import { MetaReducer, StoreModule } from '@ngrx/store';
import { AuthEffects } from '@app/core/auth/auth.effects';
import { authReducer } from '@app/core/auth/auth.reducer';
import { debug } from '@app/core/meta-reducers/debug.reducer';
import { initStateFromLocalStorage } from '@app/core/meta-reducers/init-state-from-local-storage.reducer';
import { loggingProviders } from '@app/core/logging/logging.providers';
import { AuthInterceptor } from '@app/core/auth/auth.interceptor';
import { OAuthModule } from 'angular-oauth2-oidc';

export const metaReducers: MetaReducer<any>[] = [initStateFromLocalStorage];

if (!environment.production) {
  metaReducers.unshift(debug);
}

@NgModule({
  imports: [
    // angular
    CommonModule,
    HttpClientModule,

    // ngrx
    StoreModule.forRoot(
      {
        auth: authReducer as any
      },
      { metaReducers }
    ),
    EffectsModule.forRoot([AuthEffects]),
    // Auth module
    OAuthModule.forRoot({
      resourceServer: {
        allowedUrls: [
          environment.apiEndpoint
        ],
        sendAccessToken: true
      }
    }),

    // App Insights module replaced with @microsoft/applicationinsights-web (see AppInsightsService)
  ],

  providers: [
    // AppInsightsService is providedIn: 'root' via the official Microsoft SDK wrapper
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    ...loggingProviders,
  ]
})
export class CoreModule {
  constructor() {
    const parentModule = inject(CoreModule, { optional: true, skipSelf: true })!;

    if (parentModule) {
      throw new Error('CoreModule is already loaded. Import only in AppModule');
    }
  }
}
